import { useGetIdentity, useTranslate } from "ra-core";

import { Badge } from "@/components/ui/badge";

import type { AppRole } from "../types";

/**
 * Whether the current identity is direccion, the only role that may see test
 * data (the DEMO project and its leads). Cosmetic only: the database RLS
 * hides those rows from every other role, this just avoids stray labels.
 */
export const useIsDireccion = (): boolean => {
  const { identity } = useGetIdentity();
  return (identity?.role as AppRole | undefined) === "direccion";
};

/**
 * "Datos de prueba" badge for a test deal or the DEMO project (demo isolation,
 * batch ED). Renders nothing unless `isTestData` is true and the viewer is
 * direccion.
 */
export const TestDataBadge = ({
  isTestData,
  className,
}: {
  isTestData?: boolean | null;
  className?: string;
}) => {
  const translate = useTranslate();
  const isDireccion = useIsDireccion();
  if (!isTestData || !isDireccion) return null;

  return (
    <Badge
      variant="secondary"
      className={className}
      data-testid="test-data-badge"
    >
      {translate("crm.common.test_data_badge", { _: "Test data" })}
    </Badge>
  );
};
